module.exports = __webpack_public_path__ + "img/undraw_empty_xct9.cfb49f55.svg";